


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { ToastApi } from '@/services/api/api.toasts';
import { ValidationObserver } from 'vee-validate/dist/types/components/Observer';
import { Toast } from '@/types/apiServerContract';

@Component
export default class DeleteSlider extends Vue {
	@Prop({ required: true, type: Array }) toasts!: Toast[];

	permissions: string[] = [ApiPermissions.Toast.Delete];

	toastId: string = '';

	loading: boolean = false;

	async DeleteToast() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish delete this toast?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;

	    try {
	        await ToastApi.DeleteToast(this.toastId);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Toast deleted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.$emit('delete', this.toastId);

	    this.Reset();
	    this.$nextTick(() => {
	        this.$refs.validator.reset();
	    });
	}

	public $refs!: {
		validator: InstanceType<typeof ValidationObserver>;
	};

	Reset() {
	    this.toastId = this.toasts[0].id;
	}

	mounted() {
	    this.Reset();
	}
}
